module.exports = __webpack_public_path__ + "static/media/radio-0-norm.a27a8d40.svg";